export default __webpack_public_path__ + "static/media/Graveyard.d104c1a8.jpg";